module.exports = __webpack_public_path__ + "img/record_1.57d2575b.png";